import React from "react";
import "../css/ProjectCard.css"; // Add a CSS file for responsive styles

const ProjectCard = ({ title, description, status, image, index }) => {
  const [showModal, setShowModal] = React.useState(false);
  const statusBg = status === "ongoing" ? "#ff6b35" : "#27ae60";
  const statusText = status === "ongoing" ? "In Progress" : "Completed";

  return (
    <>
      <div
        className="project-card"
        style={{ animationDelay: `${index * 0.1}s` }}
        onMouseEnter={(e) => {
          e.currentTarget.classList.add("hover");
        }}
        onMouseLeave={(e) => {
          e.currentTarget.classList.remove("hover");
        }}
      >
        {/* Image Section */}
        {image && (
          <div className="project-card-image">
            <img
              src={image}
              alt={title}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/400x300?text=" + encodeURIComponent(title);
              }}
            />
          </div>
        )}

        {/* Content Section */}
        <div className="project-card-content">
          <div>
            <h3>{title}</h3>
            <p>{description}</p>
          </div>

          {/* Bottom Section */}
          <div className="project-card-footer">
            <span className="project-card-status" style={{ backgroundColor: statusBg }}>
              <span className="status-dot"></span>
              {statusText}
            </span>
            <button
              onClick={() => setShowModal(true)}
              onMouseEnter={(e) => e.currentTarget.classList.add("hover")}
              onMouseLeave={(e) => e.currentTarget.classList.remove("hover")}
            >
              View →
            </button>
          </div>
        </div>
      </div>

      {/* Modal for Full Details */}
      {showModal && (
        <div className="project-card-modal" onClick={() => setShowModal(false)}>
          <div className="project-card-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="project-card-modal-header">
              <div>
                <h2>{title}</h2>
                <span className="project-card-status" style={{ backgroundColor: statusBg }}>
                  {statusText}
                </span>
              </div>
              <button onClick={() => setShowModal(false)}>Close</button>
            </div>
            <p>{description}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectCard;
